import Storage from './Storage';

class AuthUtils {
  static initiatePortal(portal: string): void {
    Storage.setItem(Storage.KEYS.PORTAL, portal);
  }

  static resolvePortal(): string | null {
    return Storage.getItem(Storage.KEYS.PORTAL);
  }

  static resetPortal(): void {
    Storage.removeItem(Storage.KEYS.PORTAL);
    const appVersion = Storage.getItem(Storage.KEYS.APP_VERSION);
    Storage.clear();
    /**
     * Persisting app version
     */
    Storage.setItem(Storage.KEYS.APP_VERSION, appVersion);
  }

  static setAuthToken({token, portal}: {token: string; portal: string}): void {
    Storage.setItem(Storage.KEYS.AUTH_TOKEN, token);
    this.initiatePortal(portal);
  }

  static setAdminAuthToken({
    token,
    portal
  }: {
    token: string;
    portal: string;
  }): void {
    Storage.setItem(Storage.KEYS.ADMIN_AUTH_TOKEN, token);
    this.initiatePortal(portal);
  }

  static getAdminAuthToken(): string | null {
    return Storage.getItem(Storage.KEYS.ADMIN_AUTH_TOKEN);
  }
}

export default AuthUtils;
